export class FormHelpers {
  public static areOptionsChecked(options: any[]): number | null {
    const optionsChecked = options.filter((f) => f.isSelected).length;
    return optionsChecked ? optionsChecked : null;
  }
}
